/**
 * wudy-site-analytics.js
 * Wudy Kitchen — sitewide GA4 ecommerce alignment (Clarity + Google)
 * Uses existing Shopify/gtag bootstrap when present.
 */
(function () {
  'use strict';

  var GA4_ID = 'G-YBNTK079KS';

  function sendEvent(name, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params || {});
    }
  }

  function pagePath() {
    return window.location.pathname;
  }

  function linkLabel(el) {
    if (!el) return '';
    var text = (el.getAttribute('aria-label') || el.textContent || '').replace(/\s+/g, ' ').trim();
    return text.slice(0, 120);
  }

  function cartValueCents() {
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      /* cart total is injected on cart page via Liquid elsewhere */
    }
    var subtotal = document.querySelector('.wudy-cart-summary__subtotal-value, .totals__subtotal-value');
    return subtotal ? subtotal.textContent.trim() : undefined;
  }

  function onCheckoutClick() {
    sendEvent('begin_checkout', {
      page_path: pagePath(),
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      value: cartValueCents()
    });
  }

  function onAddToCart() {
    if (window.__wudyPdpAnalytics) return;
    sendEvent('add_to_cart', {
      page_path: pagePath(),
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    });
  }

  function bindCheckout() {
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('#checkout, [name="checkout"], .cart__checkout-button, .wudy-cart-sticky-checkout__btn');
        if (!btn) return;
        onCheckoutClick();
      },
      true
    );
  }

  function bindAddToCart() {
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.matches) return;
        if (
          form.matches('form[action*="/cart/add"]') ||
          form.matches('product-form form') ||
          form.matches('form.shopify-product-form')
        ) {
          onAddToCart();
        }
      },
      true
    );

    document.addEventListener('cart:item-added', onAddToCart);
  }

  function bindViewCart() {
    if (window.location.pathname !== '/cart') return;
    sendEvent('view_cart', {
      page_path: '/cart',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
    });
  }

  function bindNavigationClicks() {
    document.addEventListener(
      'click',
      function (e) {
        var crossLink = e.target.closest(
          '[data-section="wudy-ms-cross"] .wudy-msr-cross__card, ' +
            '[data-section="wudy-collection-cross"] a, ' +
            '.wudy-pcv3-pair__card, ' +
            '.wudy-shop-tile, ' +
            '[data-wudy-nav="cross"]'
        );
        if (crossLink) {
          sendEvent('collection_cross_click', {
            page_path: pagePath(),
            link_url: crossLink.getAttribute('href') || '',
            link_text: linkLabel(crossLink)
          });
          return;
        }

        var exitCta = e.target.closest(
          '.wudy-ms-exit__cta, ' +
            '.wudy-tc-portal__cta--primary, ' +
            '.s26-portal__cta--primary, ' +
            '.wg-exit__cta, ' +
            '[data-wudy-nav="exit"]'
        );
        if (exitCta) {
          sendEvent('exit_portal_click', {
            page_path: pagePath(),
            link_url: exitCta.getAttribute('href') || '',
            link_text: linkLabel(exitCta)
          });
          return;
        }

        var viewProduct = e.target.closest('.ms-fset__view, .wudy-tc-featured__view, [data-wudy-nav="view-product"]');
        if (viewProduct) {
          sendEvent('view_product_click', {
            page_path: pagePath(),
            link_url: viewProduct.getAttribute('href') || '',
            link_text: linkLabel(viewProduct)
          });
        }
      },
      true
    );
  }

  function init() {
    if (typeof window.gtag !== 'function' && GA4_ID) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      gtag('js', new Date());
      gtag('config', GA4_ID, { send_page_view: true });
    }

    bindCheckout();
    bindAddToCart();
    bindViewCart();
    bindNavigationClicks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
